import { it } from './it';
import { en } from './en';

export const pppLanguages = {
  it,
  en,
};
